import { Component, OnInit } from '@angular/core';
import { ICollapsibleNavItemProps } from '@amobee/component-library';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../../services/user.service';
import { UserInfo } from '../../../core/classes/user-info';
import { AutoCompleteMappedItem } from '../../../common/components/auto-complete/auto-complete.component';
import { MarketAdvertiserContextService } from '../../services/market-advertiser-context.service';

@Component({
  selector: 'market-dashboard',
  templateUrl: './market-dashboard.component.html',
  styleUrls: ['./market-dashboard.component.scss']
})
export class MarketDashboardComponent implements OnInit {

  public collapsibleItems: ICollapsibleNavItemProps[] = [
    {
      icon: 'List',
      label: 'Advertisers',
      title: 'Advertisers',
      active: true,
      linkProps: {
        onClick: () => {
          this.router.navigate(['..', 'advertiser-list'], { relativeTo: this.route });
        }
      }
    }
  ];

  public autoCompletetConfig = {
    marketAutoCompletePromise: this.mktAdvCxtService.autoCompletePromiseSetUp("MARKET"),
    handleOnMarketSelect: (item: AutoCompleteMappedItem) => this.router.navigate(['market-dashboard', item.value, 'advertiser-list']),
    responseMapper: this.mktAdvCxtService.autoCompleteResponseMapper
  };

  public userInfo: UserInfo;

  public marketInfo: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private UserService: UserService,
    private mktAdvCxtService: MarketAdvertiserContextService
  ) { }

  ngOnInit() {
    this.UserService.getUser().then((userInfo: UserInfo) => {
      this.userInfo = userInfo;
    });
    this.marketInfo = this.route.snapshot.data.marketInfo;
  }

}
